module.exports = __webpack_public_path__ + "assets1783936157458/img/yunying-select.4194802f.svg";